import React, { useEffect, useState } from 'react';
import { Route, Routes } from 'react-router';
import { GuestOverview } from './GuestOverview';
import OrderHistoryDetailView from './OrderHistoryDetailView';
type Props = {};

export function GuestHome() {
  return (
    <>
      <Routes>
        <Route path="/orders/:id" element={<OrderHistoryDetailView />} />
        <Route path="/" element={<GuestOverview />} />
      </Routes>
    </>
  );
}
